export default __webpack_public_path__ + "static/media/profits.043e57f2.svg";